import React from 'react';
import logo from '../../assets/images/footerLogoN.svg';
import { HEADERMENU_PATH } from '../../routes/RoutesURL';
import { common_container } from '../main/dealList/components/deals/TopCard';
/* import { IoLocationSharp } from 'react-icons/io5';
import { MdEmail, MdPermPhoneMsg } from 'react-icons/md';
import { AiFillLinkedin } from 'react-icons/ai'; */
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import useIsTeamMember from '../../hooks/useIsTeamMember';
import FooterPageLink from './FooterPageLink';
const pageTab = [
    {
        title: 'Dashboard',
        url: '/',
    },
    {
        title: 'Deals',
        url: HEADERMENU_PATH.deals,
    },
    // {
    //     title: 'Activities',
    // },
    {
        title: 'Referral',
        url: HEADERMENU_PATH.referral,
    },
];

const webPage = [
    {
        title: 'Blog',
        url: 'https://www.helicap.com/blogs',
    },
    // {
    //     title: 'Events',
    //     url: '',
    // },
    {
        title: 'Glossary',
        url: 'https://www.helicap.com/glossary',
    },
];

const supportPage = [
    {
        title: 'Request a Call',
        url: 'https://meetings.hubspot.com/investor2',
    },
    {
        title: 'Inquiries',
        url: 'https://www.helicap.com/contact',
    },
    {
        title: 'FAQ',
        url: HEADERMENU_PATH.faq,
    },
    {
        title: 'LinkedIn',
        url: 'https://www.linkedin.com/company/helicap-group/mycompany',
    },
];
const legal = [
    {
        title: 'Terms of Service',
        url: 'https://www.helicap.com/terms-of-service',
    },
    {
        title: 'Privacy Policy',
        url: 'https://www.helicap.com/privacy-policy',
    },
];

const Footer: React.FC = () => {
    const isTeamMember: boolean = useIsTeamMember();
    const location = useLocation();
    /*remove referral from list as per index number*/
    if (isTeamMember) {
        pageTab.splice(2, 1);
    }
    return (
        <div className="bg-black py-4 pt-8 z-10">
            <div className={`${common_container}`}>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {/** Left Section */}
                    <div>
                        <img src={logo} alt="footerLogo" />
                        {/* <div className="grid grid-cols-3 gap-2 lg:gap-4 pl-3 pt-6">
                            <div>
                                {pageTab.map((p) => (
                                    <p
                                        className="font-[Lato] text-base mb-3 text-white cursor-pointer"
                                        key={`${p.title}`}
                                        onClick={() => {
                                            if (p.url) {
                                                navigate(p.url);
                                            }
                                        }}
                                    >
                                        {p.title}
                                    </p>
                                ))}
                            </div>
                            <div>
                                <p className="text-[#13974B] font-[Lato] text-base mb-3 cursor-pointer">Insights</p>
                                {webPage.map((p) => (
                                    <p
                                        className="font-[Lato] text-base mb-3 text-white cursor-pointer"
                                        key={`${p.title}`}
                                        onClick={() => {
                                            if (p.url) {
                                                window.open(p.url);
                                            }
                                        }}
                                    >
                                        {p.title}
                                    </p>
                                ))}
                            </div>
                            <div>
                                <p className="text-[#13974B] font-[Lato] text-base mb-3 cursor-pointer">Support</p>
                                {supportPage.map((p) => (
                                    <p
                                        className="font-[Lato] text-base mb-3 text-white cursor-pointer"
                                        key={`${p.title}`}
                                        onClick={() => {
                                            if (p.url) {
                                                window.open(p.url);
                                            }
                                        }}
                                    >
                                        {p.title}
                                    </p>
                                ))}
                            </div>
                        </div> */}
                    </div>
                    {/** End Left Section */}
                    {/**Right Section */}
                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 pl-3 lg:pl-0">
                        {/* <div> */}
                        {/* <p className="text-white text-lg font-[Lato] font-bold pt-4 uppercase">Get in touch</p> */}
                        {/* <div className="flex pt-2 lg:pt-5 mb-3"> */}
                        {/* <IoLocationSharp size={'1.6rem'} color="#406DB6" />{' '} */}
                        {/* <p className="font-[Lato] text-base ml-1 text-white">
                                    112 Robinson Road #12-01 Singapore 068902
                                </p> */}
                        {/* </div> */}
                        {/* <div className="flex mb-3"> */}
                        {/* <MdPermPhoneMsg size={'1.4rem'} color="#406DB6" />{' '} */}
                        {/* <p className="font-[Lato] text-base ml-1 text-white">+65 6909 9266</p> */}
                        {/* </div> */}
                        {/* <div className="flex mb-3"> */}
                        {/* <MdEmail size={'1.4rem'} color="#406DB6" />{' '} */}
                        {/* <p className="font-[Lato] text-base ml-1 text-white">info@heli-cap.com</p> */}
                        {/* </div> */}
                        {/* <div className="flex mb-3"> */}
                        {/* <AiFillLinkedin size={'1.4rem'} color="#406DB6" />{' '} */}
                        {/* <p className="font-[Lato] text-base ml-1 text-white">Follow on LinkedIn</p> */}
                        {/* </div> */}
                        {/* </div> */}

                        <FooterPageLink data={pageTab} titleShow={false} viaNavigation={true} />
                        <FooterPageLink data={webPage} title={'Insights'} />
                        <FooterPageLink data={supportPage} title={'Support'} />
                        <FooterPageLink data={legal} title={'Legal'} />
                    </div>
                    {/**End Right Section */}
                </div>
            </div>
            <div className="border-t  border-[#142C53] py-8 mt-4">
                <div className={common_container}>
                    <p className="text-[#B9B9B9] text-[10px] font-[Lato] text-start">
                        Helicap Securities Pte. Ltd. is registered in Singapore, regulated by the Monetary Authority of
                        Singapore and holds a Capital Markets Service License. Copyright © {moment().year()} Helicap.
                        All rights reserved.
                    </p>
                </div>
            </div>
            <div className={`py-8 ${common_container}`}>
                <label className="text-sm text-[#FFFFFF] text-start font-[Lato]">Disclaimer</label>

                {location.pathname.includes('portfolio') ? (
                    <ul className="list-disc text-[#B9B9B9] font-Lato text-xs ml-6">
                        <li>
                            Exchange Rate: All principal amount have been converted to USD for comparison purposes,
                            using the FX rates provided by{' '}
                            <a
                                href="https://openexchangerates.org"
                                className="underline"
                                target="_blank"
                                rel="noreferrer"
                            >
                                https://openexchangerates.org
                            </a>{' '}
                            (refreshed twice daily at noon and midnight SGT).
                        </li>
                        <li>
                            Investment Outstanding: This represents the total principal amount that you have invested
                            via Helicap Securities that has not been repaid, redeemed, or exited to date. For the
                            avoidance of doubt, this does not represent the current value of the investment to date
                            (i.e. The amount shown does not include any interest paid).
                        </li>
                        <li>
                            Total Invested: This represents the total principal amount that you have invested
                            historically via Helicap Securities to date.
                        </li>
                        <li>
                            Currency breakdown: The principal amount invested via Helicap Securities in its respective
                            currency, has been converted to the USD equivalent to provide a view of the portfolio
                            breakdown.
                        </li>
                        <li>
                            {' '}
                            breakdown: This breakdown provides an indicative exposure based on Helicap Securities’
                            assignment of each invested deal to a specific country/region.
                        </li>
                        <li>
                            {' '}
                            in "Investment Amount", "Outstanding Investment", "Outstanding Principal" and "Total
                            Distribution/Interest Paid To Date" may take 2 to 3 business days to reflect the exact state
                            of your portfolio.
                        </li>
                        <li>
                            Information displayed under "Maturity Date", "Outstanding Principal" and "Interest Rate
                            (p.a.)" fields shall be applicable to debt investments only.
                        </li>
                        <li>
                            The "Interest rate (p.a.)" field is an indicative metric that may be subject to management
                            and administrative fees, and/or other expenses. It may differ from the net interest rate you
                            receive.
                        </li>
                        <li>
                            The "Total Distribution/Interest paid to date" field represents the total of (1) dividend
                            distribution payout for investments in Helicap’s Fund since your initial subscription, and
                            (2) the interest paid to date for debt investments via Helicap Securities. Note that, as the
                            platform was only updated on MMM.YYYY, the interest paid from past debt investments may not
                            be included.
                        </li>
                        <li>"Interest Paid To Date" is net of Management Fees.</li>
                    </ul>
                ) : null}
                <p className="text-xs text-[#B9B9B9] text-start font-[Lato] mt-4">
                    Information herein is based on sources we believe to be accurate and reliable as at the date it was
                    made. We reserve the right to revise any information herein at any time without notice. Past
                    performance, or any prediction, projection or forecast, is not indicative of future performance.
                </p>
            </div>
        </div>
    );
};

export default Footer;
